import { ActionIcon, useComputedColorScheme, useMantineColorScheme } from '@mantine/core';
import { IconMoon, IconSun } from '@tabler/icons-react';
import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

function ColorSchemeToggle() {
    const { t } = useTranslation('common');
    const { setColorScheme } = useMantineColorScheme();
    const isDark = useComputedColorScheme('dark') === 'dark';

    const toggle = useCallback(
        () => setColorScheme(isDark ? 'light' : 'dark'),
        [isDark, setColorScheme]
    );

    return (
        <ActionIcon
            variant="subtle"
            color="gray"
            size="lg"
            onClick={toggle}
            aria-label={t(isDark ? 'theme.light' : 'theme.dark', isDark ? 'Light' : 'Dark')}
        >
            {isDark ? <IconSun size={20} /> : <IconMoon size={20} />}
        </ActionIcon>
    );
}

export default memo(ColorSchemeToggle);
